import React, {useContext} from "react"
import classNames from "classnames";
import _ from "lodash"
import {canCheckout} from "../AddToCart"
import CartImg from "../../images/Main/cart.svg"
import CartContext from "../../components/Context/CartContext"

export default ({cart}) => {
  let errorCount = 0
  let sellingStatuses = []
  let sellingStatusError = false
  let cartCount = 0
  const {cartLoading} = useContext(CartContext)

  _.forEach(_.get(cart, "ItemElements"), item => {
    cartCount++
    if (!canCheckout(item.Note)) {
      errorCount++
    }
    sellingStatuses.push(item.sellingStatus)
  })
  sellingStatuses = sellingStatuses.filter((elem, index, self) => self.indexOf(elem) === index)
  if (
    sellingStatuses.includes("5") && sellingStatuses.length > 1
  ) {
    sellingStatusError = true
  }

  return (
    <>
      {_.get(cart, "ResultCnt", 0) > 0 ? (
        <>
          <div style={{
            padding: "24px 0",
            borderTop: "1px solid #ccc",
            borderBottom: "1px solid #ccc",
          }}>
            <p style={{
              fontSize: "16px",
              textAlign: "center",
            }}>{_.get(cart, "ItemQtyTotal")}点 小計： <span style={{
              fontSize: "22px",
              fontWeight: "bold",
            }}>&yen;{parseInt(_.get(cart, "ItemTotal")).toLocaleString()}</span>（税込）</p>
          </div>
          {errorCount > 0 && <p className="comment error center" style={{paddingTop: "30px"}}>購入できない商品が含まれています</p> }
          {sellingStatusError && <p className="comment error center" style={{paddingTop: "30px"}}>一緒に購入できない商品が含まれています。</p> }
          <div
            style={{
              textAlign: "center",
              padding: "30px 0",
            }}
            className={classNames({loading: cartLoading})}
          >
            {errorCount > 0 || sellingStatusError ? (
              <button type="button" className="error" style={{
                width: "280px",
                padding: "8px 30px",
                color: "white",
                fontSize: "17px",
                borderRadius: "24px",
                boxSizing: "border-box",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "15px center",
                backgroundImage: `url(${CartImg})`,
              }}>購入できません</button>
            ) : (
              <a href={`${process.env.MODD_CART_URL}member/CheckOut.aspx?ccode=${process.env.MODD_CART_ID}`} style={{
                display: "inline-block",
                width: "280px",
                padding: "8px 30px",
                color: "var(--button-color-inverse)",
                fontSize: "17px",
                borderRadius: "24px",
                boxSizing: "border-box",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "15px center",
                backgroundImage: `url(${CartImg})`,
                backgroundColor: "var(--theme-color)",
              }}>購入する</a>
            )}
          </div>
        </>
      ) : (
        <p style={{
          padding: "40px 0 10px",
          textAlign: "center",
        }}>カートに商品は入っていません。</p>
      )}
    </>
  )
}
